export const IMAGE_UPLOAD_SIZE = 256 * 1024;
